import { gql } from '@apollo/client';

export const CREATE_PROVIDER_USER = gql`
  mutation CreateProviderUser($input: CreateProviderUserInput!) {
    createProviderUser(input: $input) {
      user {
        id
        username
        email
        roles
      }
      message
      statusCode
      generatedPassword
    }
  }
`;
